export const COMBINED_TRANSPORTATION = {
  _id: '653366d95d46365654923730',
  name: { en: 'combined', fa: 'ترکیبی' },
};

export const AIRPLANE_TRANSPORTATION = {
  _id: '653365925d46365654923729',
  name: {
    en: 'flight',
    fa: 'هواپیما',
  },
};
